import { useState, useEffect } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import CertificateCanvas from "@/components/CertificateCanvas";
import { downloadImage, printElement } from "@/lib/pdf";
import { Printer, Image as ImageIcon } from "lucide-react";

export const CERT_DEFAULTS = {
  frame: "none",
  customFrame: null,
  showPhoto: true,
  title: "Sertifikat Aqiqah",
  body: "Alhamdulillah Telah Melaksanakan Ibadah Sunnah Aqiqah Sesuai Syariat Islam, Semoga Allah Subhanahu Wa Ta'ala Menerima Ibadah Aqiqahnya Dan Memberikan Barokah Kepada Keluarga. Serta Ananda Menjadi Anak Yang Sholeh/Sholehah Berbakti Kepada Orang Tua, Juga Menjadi Penolong Agama Allah Subhanahu Wa Ta'ala, Aamiin Ya Rabbal 'Alamin",
  address: "Jl. Gedebage Selatan No. 24 A Kel. Rancabolang Kec. Gedebage, Bandung",
  phone: "0821-2833-5747",
};

export default function Certificate({ order, open, onClose }) {
  const [cfg, setCfg] = useState(CERT_DEFAULTS);

  useEffect(() => {
    if (!open) return;
    api.get("/settings/certificate", { params: { branch_id: order?.branch_id } }).then(({ data }) => setCfg({ ...CERT_DEFAULTS, ...data })).catch(() => setCfg(CERT_DEFAULTS));
  }, [open, order?.branch_id]);

  if (!order) return null;
  const o = order;  const childName = o.child_name || o.aqiqah_name || "-";

  const data = {
    childName,
    father: o.father_name || "",
    mother: o.mother_name || "",
    eventDate: o.event_date || o.schedule_date,
    birth: o.child_birth,
    photoUrl: o.photo_url,
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-h-[92vh] max-w-3xl overflow-y-auto p-0">
        <DialogTitle className="sr-only">Sertifikat Aqiqah {o.order_number}</DialogTitle>
        <div className="flex flex-wrap items-center justify-between gap-2 border-b border-brand-line px-6 py-4 no-print">
          <h2 className="font-serif text-xl font-bold text-brand-espresso">Sertifikat Aqiqah <span className="text-sm font-sans font-normal text-brand-muted">(10R Potrait)</span></h2>
          <div className="flex flex-wrap gap-2">
            <Button onClick={() => downloadImage("certificate-print", `sertifikat-aqiqah-${o.order_number}.jpg`)} data-testid="jpg-certificate-btn"
              variant="outline" className="gap-2 border-brand-line">
              <ImageIcon className="h-4 w-4" /> JPG
            </Button>
            <Button onClick={() => printElement("certificate-print", { fullBleed: true, paper: { css: "203mm 254mm", wpx: 768, hpx: 960 } })} data-testid="print-certificate-btn"
              className="gap-2 bg-brand-gold text-brand-espresso hover:bg-brand-goldhover">
              <Printer className="h-4 w-4" /> Cetak
            </Button>
          </div>
        </div>

        <div className="flex justify-center bg-brand-surface p-4">
          <CertificateCanvas id="certificate-print" cfg={cfg} data={data} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
